import React from "react"
import { useTranslation } from "react-i18next"
import AssocAnimalIcon from "@/assets/icons/task/assoc-animal-icon.tsx"
import styles from "@/components/shadcn/drawer/custom-drawer.module.css"

interface CustomTriggerProps {
  currentValue: string[] | string
  onClick: () => void
}

const DrawerAnimalsAssocTrigger = React.forwardRef<
  HTMLDivElement,
  CustomTriggerProps
>(({ currentValue, onClick }, ref) => {
  const { t } = useTranslation()

  function getAssociatedAnimalsInfo() {
    const isMultiple = Array.isArray(currentValue)
    const length = isMultiple ? currentValue.length : 1

    if (length === 0 || currentValue === "") {
      return t("noAnimalAssociated")
    } else if (length === 1) {
      return t("oneAnimalAssociated")
    } else {
      return `${length} ` + t("animalsAssociated")
    }
  }

  return (
    <div className={styles["task-card-item"]} ref={ref} onClick={onClick}>
      <div className={styles["task-card-header"]}>
        <div className={styles["icon-wrapper"]}>
          <AssocAnimalIcon />
          <div>
            <p>{t("AssociateAnimal")}</p>
            <p className={styles["info"]}>{getAssociatedAnimalsInfo()}</p>
          </div>
        </div>
      </div>
    </div>
  )
})

DrawerAnimalsAssocTrigger.displayName = "DrawerAnimalsAssocTrigger"

export default DrawerAnimalsAssocTrigger
